import * as React from "react";

import { UploadAttachment } from "../utils/ServiceManagerAPI";
import { Box, FileInput, Text } from "grommet";
import SkeletonWrapper from "./SkeltonWrapper";

export interface Attachment {
    id?: string;
    name: string;
    questionId: string;
    questionnaireId: string;
    content: string;
    contentType: string;
}

const AttachmentUpload = ({ questionId, questionnaireId, done }: { questionId: string; questionnaireId: string; done?: Function }) => {
    const [id, setId] = React.useState(Math.floor(Math.random() * 100000).toString());
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState("");

    const handleContentChange = (e) => {
        for (let i = 0; i < e.target.files.length; i++) {
            let content = e.target.files[i];

            if (content) {
                setLoading(true);
                var reader = new FileReader();
                reader.readAsDataURL(content);
                reader.onload = (evt: any) => {
                    UploadAttachment({
                        content: evt.target.result.replace(/^data:(\w+|\-|\/|\.)+;base64,/, ""),
                        contentType: content.type,
                        name: content.name,
                        questionId: questionId,
                        questionnaireId: questionnaireId,
                    })
                        .then((res) => {
                            done && done(res);
                            setLoading(false);
                        })
                        .catch(() => {
                            setLoading(false);
                            setError("There was an error uploading the attachment");
                        });
                };
            }
        }
    };

    return (
        <Box>
            <FileInput disabled={loading} id={id} onChange={handleContentChange} multiple />
            <Text size="small">
                The maximum size for an attachment is <Text color="brandColor">20MB</Text>, if your submission is larger than 20MB consider uploading it as separate files.
            </Text>

            <SkeletonWrapper loading={loading}>
                <></>
            </SkeletonWrapper>

            {error && <Text color="status-critical">{error}</Text>}
        </Box>
    );
};
export default AttachmentUpload;
